import { useDeleteEntityApi } from '@/common/api/deleteEntityApi';
import { usePackageStore } from 'shared/packages/stores/packageStore';

export function useDeletePackage() {
  const store = usePackageStore();

  return useDeleteEntityApi({
    url: 'package',
    translate: (t) => t.packages.actions.delete,
    async processOk(request) {
      store.remove(request.id);
      return Promise.resolve({ ok: true });
    },
  });
}
